<div class="d-flex flex-column h-100 pt-3">
  <div class="toogle-container">
    <mat-button-toggle-group [(ngModel)]="selectedType" class="foreground-type-toggle">
      <mat-button-toggle [value]="foregroundTypes.Rss" [disabled]="isRssTabDisabled">
        <mat-icon svgIcon="rss" class="small-icon p-0"></mat-icon>
        <span>
          RSS/Ticker
        </span>
      </mat-button-toggle>
      <mat-button-toggle [value]="foregroundTypes.ClockTimer" [disabled]="isTimerTabDisabled">
        <mat-icon svgIcon="timer" class="small-icon p-0"></mat-icon>
        <span>
          Clock/Timer
        </span>
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <ng-container [ngSwitch]="selectedType">
    <tab-rss-ticker *ngSwitchCase="foregroundTypes.Rss"
      [playlist]="playlist"
      [playlistItem]="playlistItem"
      (cancel)="cancel()"
      (submit)="submit()">
    </tab-rss-ticker>

    <tab-timer *ngSwitchCase="foregroundTypes.ClockTimer"
      [playlistItem]="playlistItem"
      (cancel)="cancel()"
      (submit)="submit()">
    </tab-timer>
  </ng-container>
</div>
